export class SettingModel {
  host: string;
  port: number;
  username: string;
  password: string;
  accountName: string;
  accountKey: string;
  bucket: string;
  bucketRegion: string;
  evolutionUrl: string;
  evolutionKey: string;
  openaiKey: string;

  constructor(data?: Partial<SettingModel>) {
    Object.assign(this, data);
  }
}

export interface OfflineModeModel {
  uf: string;
  active: boolean;
}

export interface OfflineModesModel {
  offlineMode: Record<string, boolean>;
}
